export const isEmpty = (object) => {
  return !Object.keys(object).length;
};
